exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-audiochat-window-audio-panel{width:100%;height:100%}#asseco-audiochat-window-audio-panel .audio-btn{position:absolute;right:calc(60% - 50px);bottom:10px;z-index:100}#asseco-audiochat-window-audio-panel .audio-playing{animation:audio-play-blink 1s infinite}@keyframes audio-play-blink{0%{width:56px;height:56px}to{width:74px;height:74px}}", ""]);

// exports
